module.exports = { "default": require("core-js/library/fn/object/define-property"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/object/define-property.js
// module id = 148
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 19